import React, { Component } from 'react'
import { withStyles } from 'material-ui/styles'
import Icon from 'material-ui/Icon'
import { CircularProgress } from 'material-ui/Progress'
import Snackbar from 'material-ui/Snackbar'
import Button from "material-ui/Button";
import Table, {
	TableBody,
	TableCell,
	TableHead,
	TableRow
} from 'material-ui/Table'
import Dialog, {
	DialogTitle,
	DialogContent,
	DialogActions
} from 'material-ui/Dialog'
import List, {
	ListItem,
	ListItemText
} from 'material-ui/List'
import { get, post } from '../../services/apiServices'
import { token } from '../../services/authServices'
import ReactPaginate from 'react-paginate'

const styles = {
	progressWrapper: {
		display: 'flex',
		height: '100%',
		justifyContent: 'center',
		alignItems: 'center',
	},
	progress: {
	},
	closeIcon: {
		position: 'absolute',
		top: '10px',
		right: '10px',
		color: '#a9a9a9',
		cursor: 'pointer'
	},
	isPlayer: {
		color: "green"
	},
	noPlayer: {
		color: "red"
	},
	editIcon: {
		padding: '10px',
		cursor: 'pointer'
	},
	titleWrap: {
		marginTop: '15px',
		display: 'flex',
		justifyContent: 'space-between',
		alignItems: 'center',
	},
	title: {
		color: '#3f51b5'
	},
	table: {
		minWidth: 700,
	},
	tableRow: {
		cursor: 'pointer'
	},
	listItem: {
		width: "480px",
		alignItems: "flex-start",
		borderBottom: "1px solid rgba(224, 224, 224, 1)"
	},
	listItemText: {
		flex: "1 1 50%"
	},
	listItemTtitle: {
		fontWeight: 600
	},
}

class Users extends Component {
	constructor(props) {
		super(props)

		this.state = {
			'users': null,
			'userInfo': {},
			'open': false
		}
	}

	getUsers = id => {
		this.props.initUsers(id)
	}

	handleOpenModal = () => {
		this.setState({ 'open': true })
	}

	handleCloseModal = () => {
		this.setState({
			'open': false
		})
	}

	getUserInfo = (id, e) => {
		e.stopPropagation()

		get(`/admin/accounts/${this.props.accountId}/users/${id}`, token).then(res => {
			let userInfo = res.data

			this.setState({
				'userInfo': userInfo.data,
				'open': true
			})
		})
	}

	handlePageChange = (id, action) => {
		this.props.pageChange(id, action.selected + 1).then(res => {
			this.setState({ 'users': this.props.users })
		})
	}

	handleOpenModalConfirm = (id, e) => {
		e.stopPropagation()

		this.setState({
			'openConfirm': true,
			'deleteId': id
		})
	}

	handleCloseModalConfirm = () => {
		this.setState({
			'openConfirm': false,
			'deleteId': null
		})
	}

	delete = id => {
		post(`/admin/users/${id}/delete`, {}, token).then(res => {
			this.handleCloseModalConfirm()
			this.getUsers(this.props.accountId)
		}).catch(err => {
			this.setState({
				'openSnackbar': true,
				'message': `User id "${id}" doesn't exist`
			})
		})
	}

	renderUsersList = () => {
		let items = this.props.users ?
			this.props.users.data : []
		let result = []

		items.map(item => {
			result.push(
				<TableRow key={item.id}>
					<TableCell padding='none'>
						{item.first_name} {item.last_name}
					</TableCell>
					<TableCell padding='none'>
						{item.user_name}
					</TableCell>
					<TableCell padding='none'>
						{item.email}
					</TableCell>
					<TableCell padding='none'>
						{item.type}
					</TableCell>
					<TableCell width="100px" padding='none'>
						<Icon
							className={this.classes.editIcon}
							onClick={(e) => this.getUserInfo(item.id, e)}>
							info_outline
						</Icon>
						<Icon
							className={this.classes.editIcon}
							onClick={(e) =>
								this.handleOpenModalConfirm(item.id, e)}>
							delete
						</Icon>
					</TableCell>
				</TableRow>
			)
		})

		return result.map(item => item)
	}

	renderUserInfoList = () => {
		let items = this.state.userInfo
		let result = []

		if (items.first_name)
			result.push(
				<ListItem className={this.classes.listItem}>
					<ListItemText
						className={this.classes.listItemText}>
						<span className={this.classes.listItemTtitle}>
							First Name
						</span>
					</ListItemText>
					<ListItemText className={this.classes.listItemText}>
						{items.first_name}
					</ListItemText>
				</ListItem>
			)

		if (items.last_name)
			result.push(
				<ListItem className={this.classes.listItem}>
					<ListItemText
						className={this.classes.listItemText}>
						<span className={this.classes.listItemTtitle}>
							Last Name
						</span>
					</ListItemText>
					<ListItemText className={this.classes.listItemText}>
						{items.last_name}
					</ListItemText>
				</ListItem>
			)

		if (items.user_name)
			result.push(
				<ListItem className={this.classes.listItem}>
					<ListItemText
						className={this.classes.listItemText}>
						<span className={this.classes.listItemTtitle}>
							Username
						</span>
					</ListItemText>
					<ListItemText className={this.classes.listItemText}>
						{items.email}
					</ListItemText>
				</ListItem>
			)

		if (items.email)
			result.push(
				<ListItem className={this.classes.listItem}>
					<ListItemText
						className={this.classes.listItemText}>
						<span className={this.classes.listItemTtitle}>
							Email
						</span>
					</ListItemText>
					<ListItemText className={this.classes.listItemText}>
						{items.email}
					</ListItemText>
				</ListItem>
			)

		if (items.type)
			result.push(
				<ListItem className={this.classes.listItem}>
					<ListItemText
						className={this.classes.listItemText}>
						<span className={this.classes.listItemTtitle}>
							Type
						</span>
					</ListItemText>
					<ListItemText className={this.classes.listItemText}>
						{items.type}
					</ListItemText>
				</ListItem>
			)

		if (items.game_state)
			result.push(
				<ListItem className={this.classes.listItem}>
					<ListItemText
						className={this.classes.listItemText}>
						<span className={this.classes.listItemTtitle}>
							Game State
						</span>
					</ListItemText>
					<ListItemText className={this.classes.listItemText}>
						{items.game_state}
					</ListItemText>
				</ListItem>
			)

		if (items.updated_at) {
			let date = new Date(items.updated_at.date)
			let year = date.getFullYear()
			let month = date.getMonth() + 1 < 10 ?
				"0" + (date.getMonth() + 1) : date.getMonth() + 1
			let day = date.getDay() < 10 ?
				"0" + date.getDay() : date.getDay()
			result.push(
				<ListItem className={this.classes.listItem}>
					<ListItemText
						className={this.classes.listItemText}>
						<span className={this.classes.listItemTtitle}>
							Last update
						</span>
					</ListItemText>
					<ListItemText className={this.classes.listItemText}>
						{`${year}-${month}-${day}`}
					</ListItemText>
				</ListItem>
			)
		}


		return result.map(item => item)
	}

	componentDidMount() {
		this.getUsers(this.props.accountId)
	}

	classes = this.props.classes;

	render() {
		const { userInfo } = this.state
		const { users } = this.props
		let isFetching = users ? users.isFetching : true
		let last_page = users && users.meta ? users.meta.last_page : 1
		let current_page = users && users.meta ? users.meta.current_page : 1

		return (
			isFetching ?
				<div className={this.classes.progressWrapper}>
					<CircularProgress
						className={this.classes.progress}
						size={50}
					/>
				</div>
				:
				<div>
					<Snackbar
						anchorOrigin={{
							vertical: 'top',
							horizontal: 'center',
						}}
						open={this.state.openSnackbar}
						autoHideDuration={6000}
						onClose={this.handleCloseSnackbar}
						SnackbarContentProps={{
							'aria-describedby': 'message-id',
						}}
						message={<span id="message-id">{this.state.message}</span>}
					/>
					<Dialog
						open={this.state.openConfirm}
						onClose={this.handleCloseModalConfirm}>
						<DialogTitle>
							<Icon
								className={this.classes.closeIcon}
								onClick={this.handleCloseModalConfirm}>
								close
							</Icon>
							<br />
							Are you sure you want delete this user?
						</DialogTitle>
						<DialogActions className={this.classes.justifyCenter}>
							<Button
								variant="raised"
								color="primary"
								onClick={() => this.delete(this.state.deleteId)}>
								Yes
							</Button>
							<Button
								variant="raised"
								color="primary"
								onClick={this.handleCloseModalConfirm}>
								No
							</Button>
						</DialogActions>
					</Dialog>
					<Dialog
						open={this.state.open}
						onClose={this.handleCloseModal}>
						<Icon
							className={this.classes.closeIcon}
							onClick={this.handleCloseModal}>
							close
					</Icon>
						<DialogTitle>
							{userInfo.first_name} {userInfo.last_name}
						</DialogTitle>
						<DialogContent>
							<List>
								{this.renderUserInfoList()}
							</List>
						</DialogContent>
					</Dialog>
					{
						users && users.data.length ?
							(
								<div>
									<div className={this.classes.titleWrap}>
										<h2 className={this.props.classes.title}>Users</h2>
									</div>
									<Table className={this.classes.table}>
										<TableHead>
											<TableRow>
												<TableCell padding='none'>
													NAME
										</TableCell>
												<TableCell padding='none'>
													EMAIL
										</TableCell>
												<TableCell padding='none'>
													TYPE
										</TableCell>
												<TableCell padding='none'>
													INFO
										</TableCell>
										<TableCell padding='none'>
													ACTIONS
										</TableCell>
											</TableRow>
										</TableHead>
										<TableBody>
											{this.renderUsersList()}
										</TableBody>
									</Table>
								</div>
							) :
							(
								<p>Not found</p>
							)
					}
					{last_page > 1 ?
						(<ReactPaginate previousLabel={<Icon color="primary">navigate_before</Icon>}
							nextLabel={<Icon color="primary">navigate_next</Icon>}
							breakLabel={<a href="">...</a>}
							breakClassName={"break-me"}
							pageCount={last_page = this.state.data ? this.state.data.meta.last_page : last_page}
							initialPage={current_page = this.state.data ? this.state.data.meta.current_page - 1 : current_page - 1}
							disableInitialCallback={true}
							marginPagesDisplayed={2}
							pageRangeDisplayed={5}
							onPageChange={action => this.handlePageChange(this.props.accountId, action)}
							containerClassName={"pagination"}
							subContainerClassName={"pages pagination"}
							activeClassName={"active"} />)
						: ''
					}
				</div>
		)
	}
}

export default withStyles(styles)(Users);



// WEBPACK FOOTER //
// ./src/components/content/Users.js